import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import Icon from "./link.svg";

import "../styles.css";

export default class lSLInks extends Plugin {
    static get pluginName() {
        return "lSLInks";
    }

    constructor(editor) {
        super(editor);
    }

    init() {
        //console.log('lSLInks#init() got called');
        // on récupère l'objet editor de l'éditeur
        const editor = this.editor;

        editor.ui.componentFactory.add("ls_links", (locale) => {
            const button = new ButtonView(locale);

            button.set({
                label: "Lien hypertexte",
                icon: Icon,
                tooltip: true,
            });

            this.listenTo(button, "execute", (e) => {
                this._make_form();
            });

            return button;
        });
    }

    _GetSelection() {
        let data = {
            href: "",
            text: "",
        };

        const editor = this.editor;
        const selection = editor.model.document.selection.getFirstRange();

        for (const item of selection.getItems()) {
            for (const attribute of item.getAttributes()) {
                if (attribute[0] === "linkHref") {
                    data.href = attribute[1];
                }
            }
            data.text = item.data;
            return data;
        }
    }

    _make_form() {
        const type = {
            tel: "Téléphone",
            mailto: "Email",
        };

        let selectedText = this._GetSelection();

        if (selectedText.text === "") {
            alert("Veuillez sélectionner un texte");
            return;
        }

        let dialog = document.getElementById("edithDialog");
        console.log(dialog);
        dialog.innerHTML = "";
        dialog.showModal();

        let form = document.createElement("form");
        form.setAttribute("id", "form");
        form.classList.add("dialog_form");

        let inputLinkLabel = document.createElement("label");
        inputLinkLabel.setAttribute("for", "ls_links");
        inputLinkLabel.textContent = "Lien hypertexte";

        let inputLink = document.createElement("input");
        inputLink.setAttribute("id", "ls_links");
        inputLink.setAttribute("type", "url");
        inputLink.setAttribute("placeholder", "https://www.example.com");
        inputLink.setAttribute("required", "true");

        if (selectedText.href) {
            inputLink.value = selectedText.href;
        }

        let submit = document.createElement("button");
        submit.setAttribute("id", "submit");
        submit.setAttribute("type", "submit");
        submit.classList.add("dialog_submit");
        submit.textContent = "Insérer";

        let cancel = document.createElement("button");
        cancel.setAttribute("id", "cancel");
        cancel.setAttribute("type", "button");
        cancel.classList.add("dialog_cancel");
        cancel.textContent = "Fermer";

        form.appendChild(inputLinkLabel);
        form.appendChild(inputLink);

        form.appendChild(submit);
        form.appendChild(cancel);
        dialog.appendChild(form);

        this._submitForm(selectedText);
        this._closeForm();
    }

    _submitForm(selectedText) {
        let form = document.getElementById("form");

        form.addEventListener("submit", (e) => {
            e.preventDefault();

            let inputLink = document.getElementById("ls_links");
            let content = inputLink.value;
            let finalLink = `<a href="${content}" title="${selectedText.text}">${selectedText.text}</a>`;

            this._insertBloc(finalLink);
        });
    }

    _closeForm() {
        let cancel = document.getElementById("cancel");
        cancel.addEventListener("click", () => {
            let dialog = document.getElementById("dialog");
            dialog.close();
        });
    }

    _insertBloc(finalLink) {
        let editor = this.editor;
        let viewFragment = editor.data.processor.toView(finalLink);
        let modelFragment = editor.data.toModel(viewFragment);
        editor.model.insertContent(modelFragment);
        //console.log('insertion ok');
        let dialog = document.getElementById("dialog");
        dialog.close();
    }
}
